/* src/services/http.js - Axios instance */
import axios from "axios";
import api from "./apiEndpoints";
import eventBus from "./eventBus";

const http = axios.create({
    baseURL: api.BASE_URL || "/",
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 30000,
});

// Request interceptor
http.interceptors.request.use(
    (config) => {
        const token = JSON.parse(localStorage.getItem("token"));
        if (!config.headers) config.headers = {};
        if (!config.noApiKey) config.headers.apikey = api.API_KEY;
        if (token && !config.noApiKey) config.headers.Authorization = `Bearer ${token.access_token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
http.interceptors.response.use(
    (response) => response,
    (error) => {
        const response = error.response;
        if (!response) return Promise.reject(error);

        switch (response.status) {
            case 401:
                // Emit event so app can react (logout, redirect)
                eventBus.emit("http:unauthorized", response);
                break;
            case 403:
            case 404:
            case 422:
                eventBus.emit("http:error", response);
                break;
        }

        // if API returned error body with message, bubble it
        return Promise.reject(error);
    }
);

export default http;
